const mediaItems = [
  {
    id: 1,
    title: '顶流男星深夜密会神秘女子，酒店同框照片独家曝光',
    avatar: 'https://readdy.ai/api/search-image?query=Blurred%20paparazzi%20style%20night%20scene%20outside%20luxury%20hotel%20entrance%20with%20warm%20ambient%20lighting%2C%20cinematic%20mood%2C%20no%20recognizable%20faces%2C%20abstract%20city%20night%20atmosphere%2C%20soft%20bokeh%20lights%2C%20mysterious%20vibe&width=800&height=450&seq=media-bg-01&orientation=landscape',
    views: '128.6万',
    time: '3小时前',
    hot: true,
  },
  {
    id: 2,
    title: '某女团成员疑似恋情曝光，男方竟是圈外富二代',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20kpop%20concert%20stage%20atmosphere%20with%20colorful%20spotlights%20and%20crowd%20silhouettes%2C%20dreamy%20soft%20focus%2C%20pink%20and%20purple%20mood%20lighting%2C%20no%20recognizable%20people&width=800&height=450&seq=media-bg-02&orientation=landscape',
    views: '96.3万',
    time: '5小时前',
    hot: true,
  },
  {
    id: 3,
    title: '热门综艺录制现场爆发冲突，两位导师当场翻脸',
    avatar: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20set%20with%20red%20and%20blue%20contrasting%20lighting%2C%20empty%20judges%20chairs%20on%20stage%2C%20tension%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20people%20visible&width=800&height=450&seq=media-bg-03&orientation=landscape',
    views: '87.1万',
    time: '7小时前',
    hot: false,
  },
  {
    id: 4,
    title: '知名网红被曝偷税漏税，工作室紧急发布声明回应',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20office%20desk%20with%20scattered%20documents%20and%20a%20laptop%2C%20dramatic%20shadow%20play%2C%20warm%20desk%20lamp%20lighting%2C%20mysterious%20atmosphere%2C%20no%20identifiable%20information%20on%20papers&width=800&height=450&seq=media-bg-04&orientation=landscape',
    views: '72.5万',
    time: '9小时前',
    hot: false,
  },
  {
    id: 5,
    title: '年度最甜CP官宣分手，粉丝集体破防评论区沦陷',
    avatar: 'https://readdy.ai/api/search-image?query=Broken%20heart%20conceptual%20art%20in%20soft%20pastel%20colors%2C%20split%20composition%20with%20warm%20and%20cool%20tones%2C%20emotional%20abstract%20design%2C%20cinematic%20lighting%2C%20no%20text%20or%20faces&width=800&height=450&seq=media-bg-05&orientation=landscape',
    views: '65.8万',
    time: '11小时前',
    hot: true,
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium mb-3">
              <i className="ri-play-circle-line"></i>
              最新视频爆料
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              视频爆料
            </h2>
          </div>
          <a
            href="#"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mediaItems.map((item) => (
            <article key={item.id} className="group cursor-pointer">
              <div className="relative aspect-video rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={item.avatar}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-xs text-background-50/90 bg-foreground-950/50 backdrop-blur-sm px-2 py-0.5 rounded">
                    {item.time}
                  </span>
                  <span className="text-xs text-background-50/90 flex items-center gap-1">
                    <i className="ri-play-circle-fill text-sm"></i>
                    {item.views}
                  </span>
                </div>
                {item.hot && (
                  <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                    热门
                  </span>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                {item.title}
              </h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}